module.exports = __webpack_public_path__ + "media/src/public/img/payment/tinkoff-logo-min-bd6068def77957ca8ea54b289a57964e.svg";